import StreamGroupsManager from './StreamGroupsManagerContainer'
export default StreamGroupsManager
